import { DeliveryStatusEnum } from './enums/delivery-status.enum';
import { ColorEnum } from './enums/color.enum';

export class DeliveryStatus {
  public code!: DeliveryStatusEnum;
  public keyLabel!: string;
  public emojis!: string;
  public color!: ColorEnum;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_DELIVERY_STATUS: any = {
  INITIAL: new DeliveryStatus({
    code: DeliveryStatusEnum.INITIAL,
    keyLabel: 'DELIVERY_STATUS.INITIAL',
    emojis: '🗓️',
    color: ColorEnum.INFO,
  }),
  PICKEDUP: new DeliveryStatus({ code: DeliveryStatusEnum.PICKEDUP, keyLabel: '' }),
  INTRAVEL: new DeliveryStatus({
    code: DeliveryStatusEnum.INTRAVEL,
    keyLabel: 'DELIVERY_STATUS.INTRAVEL',
    emojis: '🚐',
    color: ColorEnum.INFO,
  }),
  IMMINENT_DELIVERY: new DeliveryStatus({
    code: DeliveryStatusEnum.IMMINENT_DELIVERY,
    keyLabel: '',
    emojis: '👍',
    color: ColorEnum.SUCCESS,
  }),
  DELIVERED: new DeliveryStatus({
    code: DeliveryStatusEnum.DELIVERED,
    keyLabel: 'DELIVERY_STATUS.DELIVERED',
    emojis: '🏆',
    color: ColorEnum.SUCCESS,
  }),
  PROBLEM: new DeliveryStatus({
    code: DeliveryStatusEnum.PROBLEM,
    keyLabel: 'DELIVERY_STATUS.PROBLEM',
    emojis: '🚨',
    color: ColorEnum.WARNING,
  }),
  CANCELED: new DeliveryStatus({
    code: DeliveryStatusEnum.CANCELED,
    keyLabel: 'DELIVERY_STATUS.CANCELED',
    emojis: '❌',
    color: ColorEnum.DANGER,
  }),
};
